/** GST and platform fee rules for rental checkout (MBR-081). */
export const GST_RATE = 0.18;
/** Platform share of rental used as GST base (70%). */
export const PLATFORM_FEE_SHARE = 0.70;
/** Customer-facing platform fee (5% of rental subtotal). */
export const CUSTOMER_PLATFORM_FEE_RATE = 0.05;

export function calculateRentalCharges(rentalSubtotal) {
  const subtotal = Math.round(rentalSubtotal || 0);
  const platformFee = Math.round(subtotal * CUSTOMER_PLATFORM_FEE_RATE);
  const gst = Math.ceil(subtotal * PLATFORM_FEE_SHARE * GST_RATE);
  return { subtotal, platformFee, gst };
}
